import React from 'react';
import AppHeader from '../components/AppHeader';
import { useLanguage } from '../i18n';

const TermsPage: React.FC = () => {
  const { dir, t } = useLanguage();

  return (
    <div className="min-h-screen bg-black text-gray-200" dir={dir}>
      <AppHeader />
      <main className="max-w-5xl mx-auto px-6 md:px-12 lg:px-16 py-16">
        <header className="mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">{t('pages.terms.title')}</h1>
          <p className="text-gray-400">{t('pages.terms.effectiveDate', { date: new Date().toLocaleDateString('en-US') })}</p>
        </header>

        <section className="space-y-6 text-lg leading-relaxed">
          <p>{t('pages.terms.intro')}</p>

          <section>
            <h2 className="text-2xl font-semibold text-white mt-10 mb-3">{t('pages.terms.sections.userResponsibilities.title')}</h2>
            <p>{t('pages.terms.sections.userResponsibilities.content')}</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mt-10 mb-3">{t('pages.terms.sections.contentOwnership.title')}</h2>
            <p>{t('pages.terms.sections.contentOwnership.content')}</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mt-10 mb-3">{t('pages.terms.sections.prohibitedUse.title')}</h2>
            <p>{t('pages.terms.sections.prohibitedUse.content')}</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mt-10 mb-3">{t('pages.terms.sections.apiUsage.title')}</h2>
            <p>{t('pages.terms.sections.apiUsage.content')}</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mt-10 mb-3">{t('pages.terms.sections.disclaimers.title')}</h2>
            <p>{t('pages.terms.sections.disclaimers.content')}</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mt-10 mb-3">{t('pages.terms.sections.liability.title')}</h2>
            <p>{t('pages.terms.sections.liability.content')}</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mt-10 mb-3">{t('pages.terms.sections.modifications.title')}</h2>
            <p>{t('pages.terms.sections.modifications.content')}</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mt-10 mb-3">{t('pages.terms.sections.contact.title')}</h2>
            <p>{t('pages.terms.sections.contact.content')}</p>
          </section>
        </section>
      </main>
    </div>
  );
};

export default TermsPage;

